export default "__VITE_ASSET__BRCo0e2___"